export default {
    blockTitle: 'Sperr kort',
    blockReorderTitle: 'Sperr/erstatt kort',

    blockCard: 'Sett sperre',
    unblockCard: 'Fjern sperre',
    orderCard: 'Bestill kort',

    blockIngress: 'Her kan du sperre og gjenåpne kortene dine',
    blockSelectCard: 'Velg kortet du ønsker å sperre',
    blockStatusHard: 'Kortet er permanent sperret',
    blockStatusReorderedSuffix: 'og rebestilt',
    reorderTitle: 'Bestill nytt kort',
    reorderLink: '/rebestill',
    reorderLinkButton: 'Rebestill kort',
    reorderingTitle: 'Bestiller nytt kort...',
    reorderErrorRejected: 'Kortbestilling avvist',
    reorderErrorAlreadyInProgress: 'Kortet er allerede bestilt',
    reorderErrorAccountNotActive:
        'Denne kontoen er ikke aktiv, vennligst ta kontakt med Eika Kundesenter ved rebestilling.',
    reorderErrorAccountOverdue:
        'Det er purring på denne kontoen, vennligst ta kontakt med Eika Kundesenter ved rebestilling.',
    reorderErrorWarning:
        'Vi har ikke mulighet til å rebestille dette kortet. Vennligst ta kontakt med Eika Kundesenter',
    blockStatusSoftPre: 'Kortet er',
    blockStatusSoftBlocked: 'sperret',
    blockStatusSoftOpen: 'åpent',
    blockSoftOpenLabel: 'Åpne midlertidig sperret kort',
    blockSoftOpen: 'Åpne kortet',
    blockSoftClose: 'Sperr kortet',
    blockSoftTitle: 'Sperr kortet midlertidig',
    blockSoftStatusText: 'Midlertidig sperret',
    blockSoftInfoBox1: 'Det kan gjenåpnes når som helst.',
    blockSoftInfoBox2:
        'Har kortet blitt stjålet eller mistet? Da kan du bestille nytt kort for samme konto. Det gamle kortet vil da bli permanent sperret.',
    blockHardStatusText: 'Sperret',
    blockHardTitle: 'Sperr kortet permanent',
    blockHardHeader: 'Sperre helt og rebestill',
    blockHardSubHeader:
        'Om du anser kortet ditt for tapt er det viktig at vi sperrer kortet helt. Oppgi årsak til at kortet er borte:',
    blockHardLost: 'Mistet',
    blockHardStolen: 'Stjålet',
    blockHardAbused: 'Misbrukt',
    blockHardOther: 'Annet',
    blockHardUnauthorizedUse: 'Uautorisert bruk',
    blockHardOtherReason: 'Andre årsaker',
    blockHardNewCard: 'Jeg vil ha et nytt kort',
    blockHardSubmitWithNew: 'Sperr og bestill nytt kort',
    blockHardSubmit: 'Sperr kortet helt',
    blockHardConfirmationProduct: 'Kortet som sperres: ',
    blockHardConfirmation: 'Årsak til sperring: ',
    blockHardSelectReason: 'Velg årsak',
    blockError: 'Noe gikk galt under sperring av kort. Vennligst prøv igjen senere.',
    blockErrorOther: 'Mangler tilgang for å gjennomføre sperring på dette kortet.',
    blockReopenError: 'Noe gikk galt under gjenåpning av kort. Vennligst prøv igjen senere.',
    blockReorderError: 'Noe gikk galt under rebestilling av kort. Vennligst prøv igjen senere.',
    changePinError: 'Noe gikk galt under endring av PIN-kode. Vennligst prøv igjen senere.',
    blockReorderErrorActiveCard: 'Kunne ikke rebestille kort. Du har allerede et aktivt kort på denne kontoen.',
    blockReorderInProgressError: 'Du har allerede et kort i bestilling.',
    blockReorderErrorNotProduced: 'Du kan ikke rebestille kort/pin når kort ikke er produsert.',
    blockReorderErrorOverdraft:
        'Selvbetjent kortbestilling er ikke mulig når kortet er overtrukket. Ditt overtrekk er på kr {overdraft}. For hjelp, kontakt Eika Kundesenter på {phone}',
    blockReorderPriceInfo: 'Erstatningskort kan koste litt penger. Sjekk prislisten.',
    blockNoReorderInfo:
        'Kortet er sperret og du kan dessverre ikke betjene det her. Kontakt Eika Kundesenter hvis du har spørsmål.',
    blockAreYouSure: 'Er du sikker?',
    blockAreYouSureBlock: 'Ja, sperr kortet',
    blockAreYouSureRenew: 'Ja, forny kortet',
    blockAreYouSureReorder: 'Ja, rebestill kortet',
    blockAreYouSureCancel: 'Avbryt',
    blockReopenQuestionText: 'Vil du åpne kortet ditt?',
    blockReopenQuestionNote: 'Hvis du åpner kortet ditt kan du begynne å bruke det igjen med en gang.',
    blockCardAction: 'Sperr kortet',
    blockStep0Legend: 'Vil du sperre kortet ditt midlertidig eller permanent?',
    blockStep0Description:
        'Hvis du sperrer kortet ditt midlertidig kan det gjenåpnes når som helst. Hvis kortet ditt virkelig er borte er det viktig at du sperrer kort helt.',
    blockStep1Legend: 'Hvorfor vil du sperre kortet ditt permanent?',
    blockStep2Legend: 'Vil du bestille nytt kort?',
    blockStep2Description: 'Du får nytt kort om 5-7 dager virkedager.',
    blockStep2AnswerYes: 'Ja, jeg vil bestille kort',
    blockStep2AnswerNo: 'Nei, jeg vil ikke bestille kort',
    blockPriceListLink: 'Se prisliste for kort',
    blockSoftSuccessMessage: 'Kortet ditt er midlertidig sperret. Du kan når som helst åpne det igjen.',
    blockHardSuccessMessage: 'Kort er sperret.',
    blockHardAndReorderedSuccessMessage: 'Kort er sperret og nytt kort er bestilt.',
    blockCardNoCardsAvailable: 'Vi finner ingen kort du kan sperre akkurat nå.',
    blockCardCardIsAlreadySoftBlocked: 'Dette kortet er allerede midlertidig sperret.',
    softBlockConfirm: 'Bekreft midlertidig sperring av kort',
    softBlockConfirmInformation: 'Du har valgt å midlertidig sperre kort med kortnummer',
    reorderOptionYes: 'Ja, jeg vil bestille nytt kort',
    reorderOptionNo: 'Nei, jeg vil ikke bestille nytt kort',
    blockStatusSoft: 'Kortet er sperret midlertidig',

    hardBlockConfirm: 'Bekreft permanent blokkering av kort',
    hardBlockConfirmDamagedCard: 'Bekreft fornyelse av skadet/ødelagt kort',
    hardBlockConfirmInfoText1: 'Du har valgt å sperre kortnummer {} permanent',
    hardBlockConfirmInfoText2: 'Nytt bankkort til {} blir bestilt, eksisterende kort {} blir sperret.',
    hardBlockConfirmInfoText2Renew:
        'Nytt bankkort til {} blir bestilt, eksisterende kort {} blir slettet automatisk etter 45 dager.',
    hardBlockConfirmInfoNoReorder: 'Nytt kort er ikke bestilt.',
    blockStatusReordered: 'Kortet er erstattet',
    blockStatusReorderedInformation: 'Du får nytt kort om 5-7 virkedager.',
    blockConfirmToAccountNumber: 'til kontonummer',

    blockCardCompleted: 'Operasjon fullført',
    chosenChangePinText: 'Du har valgt å endre PIN-kode.',
    chosenNotChangePinText: 'Du har valgt å beholde PIN-kode.',
    orderCardStep0Description: 'Normalt sett vil du motta nytt kort innen en ukes tid.',

    blockCardAccountIsNotOpen:
        'Kontoen til dette kortet er ikke i bruk. Ta kontakt med oss hvis du ønsker å bestille et nytt kort.',
    blockCardIsNotReplacable: 'Du kan dessverre ikke bestille et nytt kort til denne kontoen.',
    blockCardIsNotReplacableBecauseUnder18:
        'Du kan dessverre ikke bestille et nytt kort siden du er under 18 år. Få hjelp av en forelder eller foresatt til å bestille et nytt kort.',
    blockCardIsNotReplacableBecauseUserNotOwner:
        'Du kan dessverre ikke bestille et nytt kort fordi du ikke er eier av kontoen til dette kortet.',

    orderCardErrorBlockCardSuccess:
        'Kortet er sperret, men noe gikk galt med bestillingen av et nytt kort. Prøv igjen, eller ta kontakt med banken din for å fullføre bestillingen.',
    confirmChosenAccountNumber: 'Du har valgt å bestille et nytt kort til kontonummer',
    confirmBySmsText: 'Det blir sendt bekreftelse på SMS til mobilnummer',
    confirmBySmsText2: 'Vi har sendt en SMS-bekreftelse til mobilnummer',
    confirmWarningImmediateBlock: 'Vær oppmerksom på at kortet du erstatter blir sperret med en gang',
    orderCardConfirmReplaceText: 'Ja, erstatt kort',

    blockReason_LOST: 'Jeg har mistet kortet',
    blockReason_STOLEN: 'Kortet er stjålet eller misbrukt av andre',
    blockReason_NOT_IN_USE: 'Kortet er ikke i bruk',
    blockReason_DAMAGED: 'Kortet er skadet/ødelagt',

    systemSoftBlockInformationCreditCard:
        'Vi mangler oppdatert kundeerklæring fra deg, og kortet ditt er midlertidig sperret. Ta kontakt med Eika Kundesenter for å åpne kortet så snart kundeerklæringen er besvart.',
    systemSoftBlockInformationDebitCard:
        'Kortet ditt er midlertidig sperret, ta kontakt med Eika Kundesenter for å åpne kortet.',
    reopenCardErrorTitle: 'Åpning av kort er ikke tilgjengelig akkurat nå',
    reopenCardErrorDescription: 'Kontakt banken for mer informasjon.',
};
